/** Inline Lucide icon from /public/icons, bundled once via import.meta.glob. Stroke scales with size (2 × size / 24). */
import type { CSSProperties, ReactElement } from "react";

const files = import.meta.glob("../../public/icons/*.svg", { query: "?raw", import: "default", eager: true }) as Record<string, string>;
const inner = new Map<string, string>();
for (const [path, svg] of Object.entries(files)) {
  const name = path.slice(path.lastIndexOf("/") + 1, -4);
  const m = svg.match(/<svg[^>]*>([\s\S]*?)<\/svg>/);
  if (m) inner.set(name, m[1]!.replace(/<!--[\s\S]*?-->/g, "").replace(/>\s+</g, "><").trim());
}
export type IconName = string;
export const hasIcon = (name: string): boolean => inner.has(name);
export const iconNames = (): string[] => [...inner.keys()];

export interface IconProps { name: IconName; size?: number; stroke?: number; label?: string; className?: string; style?: CSSProperties }
export function Icon({ name, size = 24, stroke, label, className = "", style }: IconProps): ReactElement {
  const html = inner.get(name) ?? "";
  const sw = stroke ?? Math.round((2 * size / 24) * 100) / 100;
  return (
    <span className={`icon ${className}`} style={{ width: size, height: size, ...style }} data-icon={name} role={label ? "img" : undefined} aria-label={label} aria-hidden={label ? undefined : true}>
      <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round" dangerouslySetInnerHTML={{ __html: html }} />
    </span>
  );
}
